import { useNavigate } from 'react-router';
import { Archive } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useLiveQuery } from 'dexie-react-hooks';
import { Banner } from '@/components/Banner';
import { Button } from '@/components/Button';
import { hayDatosCapturados, leerSettings } from '@/db/schema';
import { sugerirRespaldoAntesDeActualizar } from '@/domain/backup-reminder';

/**
 * Aviso de versión nueva disponible (Req. 2.4).
 *
 * El complemento está configurado con `registerType: 'prompt'` y no
 * 'autoUpdate' justamente para esto: la app avisa y pide confirmación antes de
 * recargar, en lugar de recargar sola a mitad de un entrenamiento. Si el
 * último respaldo tiene más de un día, sugiere hacer uno antes; actualizar
 * nunca se bloquea por eso.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [necesitaActualizar, setNecesitaActualizar],
    updateServiceWorker,
  } = useRegisterSW();
  const navegar = useNavigate();

  const sugerencia = useLiveQuery(async () => {
    const settings = await leerSettings();
    return sugerirRespaldoAntesDeActualizar({
      ultimoRespaldoEn: settings.ultimoRespaldoEn,
      hayDatos: await hayDatosCapturados(),
    });
  }, []);

  if (!necesitaActualizar) return null;

  return (
    <Banner
      tono="info"
      titulo="Hay una versión nueva de DuoFit"
      accion={
        <div className="space-y-2">
          {sugerencia?.sugerir === true && (
            <Button
              variante="secundario"
              icono={Archive}
              onClick={() => void navegar('/mas/respaldos')}
            >
              Hacer un respaldo primero
            </Button>
          )}
          <div className="flex gap-2">
            <Button
              variante="primario"
              completo={false}
              onClick={() => {
                void updateServiceWorker(true);
              }}
            >
              Actualizar ahora
            </Button>
            <Button
              variante="secundario"
              completo={false}
              onClick={() => setNecesitaActualizar(false)}
            >
              Después
            </Button>
          </div>
        </div>
      }
    >
      <p>Al actualizar se recarga la app. Tus datos no se tocan.</p>
      {sugerencia?.sugerir === true && <p className="mt-1">{sugerencia.mensaje}</p>}
    </Banner>
  );
}
